import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export const HtmlDescription = ({
  content,
  size,
  className,
  color,
}: {
  content: string;
  className?: string;
  size: 'sm' | 'base' | 'lg' | 'xl';
  color: 'white' | 'foreground';
}) => {
  return (
    <HtmlRendererRaw
      className={cn(
        'ea-html-description',
        className,
        size === 'sm' && 'ea-html-description--sm',
        size === 'base' && 'ea-html-description--base',
        size === 'lg' && 'ea-html-description--lg',
        size === 'xl' && 'ea-html-description--xl',
        color === 'white' && 'white-description text-white',
        color === 'foreground' && 'foreground-description text-foreground',
      )}
      html={content}
    />
  );
};
